"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// THE FACILITATOR'S VENTILATOR CONTROLS (phase 3 of the ventilator plan), used by the controller's
// Ventilator section (data/screens/livesim.js).
//
//   VentPatientPanel  the patient side, shared by every ventilator in the session (live.vent): the
//                     lung adjustments (the trainer's Lungs panel), the injected problems, and
//                     Education / Assessment.
//   VentRemotePanel   one ventilator's remote control (sessions/<CODE>/ventCmd): power, start and
//                     standby, mode, every setting and alarm limit of the current mode, silence,
//                     O2 enrichment, screen lock and a fresh ventilator. Changes appear on the transport ventilator as a
//                     colleague's would and are logged as the facilitator's.
(function () {
  var _React = React,
    useState = _React.useState;
  var VP = window.VENT_PROFILES;
  var Step = function Step(_ref) {
    var label = _ref.label,
      onDown = _ref.onDown,
      onUp = _ref.onUp,
      disabled = _ref.disabled,
      children = _ref.children;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-1"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "".concat(label, " down"),
      disabled: disabled,
      onClick: onDown,
      className: "w-6 h-6 rounded bg-slate-700 text-white font-bold disabled:opacity-30"
    }, '−'), children, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "".concat(label, " up"),
      disabled: disabled,
      onClick: onUp,
      className: "w-6 h-6 rounded bg-slate-700 text-white font-bold disabled:opacity-30"
    }, "+"));
  };
  var Seg = function Seg(_ref2) {
    var label = _ref2.label,
      options = _ref2.options,
      value = _ref2.value,
      onChange = _ref2.onChange;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1",
      role: "group",
      "aria-label": label
    }, options.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        v = _ref4[0],
        text = _ref4[1];
      return /*#__PURE__*/React.createElement("button", {
        key: text,
        type: "button",
        "aria-pressed": value === v,
        onClick: function onClick() {
          if (value !== v) onChange(v);
        },
        className: "px-2 py-0.5 rounded border text-[10px] font-bold ".concat(value === v ? 'bg-cyan-700 border-cyan-400 text-white' : 'bg-slate-900 border-slate-600 text-slate-300')
      }, text);
    }));
  };
  var fmtNum = function fmtNum(v) {
    return Math.round(v * 10) / 10;
  };

  // ---- the patient: lungs, problems, Education / Assessment ---------------------------------
  var VentPatientPanel = function VentPatientPanel(_ref5) {
    var sim = _ref5.sim,
      cfg = _ref5.cfg,
      addLogEntry = _ref5.addLogEntry;
    if (!VP) return null;
    var base = VP.profiles[cfg.profile] || VP.profiles.normal;
    var lung = VP.lungFor({
      profile: cfg.profile,
      breathing: cfg.breathing
    });
    var adj = cfg.lung || {};
    var probs = VP.probList(cfg.probs);
    var setCfg = function setCfg(payload) {
      return sim.dispatch({
        type: 'SET_VENT_CONFIG',
        payload: payload
      });
    };
    var stepLung = function stepLung(k, dir) {
      var d = VP.LUNG_ADJ[k];
      var cur = adj[k] !== undefined && adj[k] !== null ? adj[k] : d.def(base);
      var v = Math.min(d.max, Math.max(d.min, Math.round((cur + dir * d.step) * 10) / 10));
      if (v === cur) return;
      setCfg({
        lung: _defineProperty({}, k, v)
      });
      addLogEntry("Ventilator lungs: ".concat(d.name.toLowerCase(), " ").concat(fmtNum(v)).concat(d.unit === '%' ? '%' : ' ' + d.unit, " (facilitator)"), 'system');
    };
    var toggleProb = function toggleProb(p) {
      var on = probs.indexOf(p.id) === -1;
      setCfg({
        probs: on ? probs.concat(p.id) : probs.filter(function (id) {
          return id !== p.id;
        })
      });
      addLogEntry(on ? "Ventilator problem injected: ".concat(p.label, " (facilitator)") : "Ventilator problem fixed: ".concat(p.label, " (facilitator)"), on ? 'warning' : 'system');
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2",
      "data-testid": "vent-patient"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap text-slate-400 uppercase font-bold text-[10px]"
    }, "On the ventilator"), /*#__PURE__*/React.createElement(Seg, {
      label: "Education or Assessment",
      value: cfg.assess === true,
      options: [[false, 'Education'], [true, 'Assessment']],
      onChange: function onChange(v) {
        setCfg({
          assess: v
        });
        addLogEntry(v ? 'Ventilator: Assessment (no alarm help on the screen) (facilitator)' : 'Ventilator: Education (alarm help on the screen) (facilitator)', 'system');
      }
    })), VP.modelOf(cfg.model) !== 'a350' ? /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2",
      "data-testid": "vent-simple"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-300 text-[10px]",
      title: "Simple shows big buttons for CPAP, NIV, NIV-ST, high-flow O2, pressure support, PSIMV, pressure control and volume control, with large \u2212 and + for the main settings, instead of the full ventilator."
    }, "Ventilator screen"), /*#__PURE__*/React.createElement(Seg, {
      label: "Ventilator screen: full or simple",
      value: cfg.simple === true,
      options: [[false, 'Full'], [true, 'Simple']],
      onChange: function onChange(v) {
        setCfg({
          simple: v
        });
        addLogEntry(v ? 'Ventilator: simple mode (big mode buttons on the screen) (facilitator)' : 'Ventilator: full ventilator on the screen (facilitator)', 'system');
      }
    })) : /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-500",
      "data-testid": "vent-simple"
    }, "Simple mode is for the transport and ICU ventilators, not the anaesthetic machine."), /*#__PURE__*/React.createElement("div", {
      "data-testid": "vent-problems"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400 uppercase font-bold text-[10px]"
    }, "Problems (press again to fix)"), probs.length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "px-2 py-0.5 rounded bg-emerald-700 text-white text-[10px] font-bold",
      onClick: function onClick() {
        setCfg({
          probs: []
        });
        addLogEntry('Ventilator problems: all fixed (facilitator)', 'system');
      }
    }, "Fix all")), VP.PROBLEM_GROUPS.map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        group = _ref7[0],
        ids = _ref7[1];
      return /*#__PURE__*/React.createElement("div", {
        key: group,
        className: "mt-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-[9px] uppercase text-slate-500 font-bold"
      }, group), /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-2 gap-1"
      }, ids.map(function (id) {
        return VP.PROBLEMS.find(function (x) {
          return x.id === id;
        });
      }).filter(Boolean).map(function (p) {
        var on = probs.indexOf(p.id) !== -1;
        return /*#__PURE__*/React.createElement("button", {
          key: p.id,
          type: "button",
          "aria-pressed": on,
          onClick: function onClick() {
            return toggleProb(p);
          },
          title: VP.PROBLEM_SIGNS[p.id] || undefined,
          className: "text-left px-1.5 py-1 rounded border text-[10px] leading-tight ".concat(on ? 'bg-red-800 border-red-400 text-white font-bold' : 'bg-slate-900 border-slate-600 text-slate-200')
        }, on ? 'Fix: ' : '', p.label);
      })));
    }), probs.filter(function (id) {
      return VP.PROBLEM_SIGNS[id];
    }).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mt-1 flex flex-col gap-0.5 text-[10px] text-amber-200",
      "data-testid": "vent-problem-signs"
    }, probs.filter(function (id) {
      return VP.PROBLEM_SIGNS[id];
    }).map(function (id) {
      return /*#__PURE__*/React.createElement("div", {
        key: id
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-bold"
      }, VP.PROBLEMS.find(function (x) {
        return x.id === id;
      }).label, ":"), " ", VP.PROBLEM_SIGNS[id]);
    })), probs.indexOf('plug') !== -1 && sim.applyIntervention && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "mt-1 w-full px-2 py-1 rounded bg-emerald-700 text-white text-[10px] font-bold",
      onClick: function onClick() {
        return sim.applyIntervention('Bronchoscopy');
      }
    }, "Bronchoscopy done: clear the plug"), probs.indexOf('endo') !== -1 && sim.applyIntervention && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "mt-1 w-full px-2 py-1 rounded bg-emerald-700 text-white text-[10px] font-bold",
      onClick: function onClick() {
        return sim.applyIntervention('TubeWithdraw');
      }
    }, "Tube pulled back: fix the endobronchial tube")), /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", {
      className: "cursor-pointer text-slate-300 font-bold"
    }, "Lungs", Object.keys(adj).length ? ' (adjusted)' : ''), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1 mt-1"
    }, VP.LUNG_ORDER.map(function (k) {
      var d = VP.LUNG_ADJ[k];
      var v = adj[k] !== undefined && adj[k] !== null ? adj[k] : d.def(base);
      var off = k === 'e' && lung.sedated;
      return /*#__PURE__*/React.createElement("div", {
        key: k,
        className: "flex items-center justify-between gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: off ? 'text-slate-500' : ''
      }, d.name), /*#__PURE__*/React.createElement(Step, {
        label: d.name,
        disabled: off,
        onDown: function onDown() {
          return stepLung(k, -1);
        },
        onUp: function onUp() {
          return stepLung(k, 1);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "w-20 text-center font-mono text-white",
        "data-testid": "vent-lung-".concat(k)
      }, fmtNum(v), /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] text-slate-400 ml-0.5"
      }, d.unit))));
    }), Object.keys(adj).length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "self-start px-2 py-0.5 rounded bg-slate-700 text-white text-[10px] font-bold",
      onClick: function onClick() {
        setCfg({
          lung: null
        });
        addLogEntry('Ventilator lungs reset to this patient (facilitator)', 'system');
      }
    }, "Reset lungs to this patient"))));
  };

  // ---- one ventilator: remote control ------------------------------------------------------
  var parseRows = function parseRows(s) {
    try {
      var a = JSON.parse(s || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) {
      return [];
    }
  };
  var ValueRow = function ValueRow(_ref8) {
    var row = _ref8.row,
      kind = _ref8.kind,
      send = _ref8.send;
    var _row = _slicedToArray(row, 5),
      k = _row[0],
      label = _row[1],
      value = _row[2],
      shown = _row[3],
      unit = _row[4];
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      draft = _useState2[0],
      setDraft = _useState2[1];
    var commit = function commit() {
      if (draft === null) return;
      var n = Number(draft);
      setDraft(null);
      if (draft.trim() !== '' && Number.isFinite(n) && n !== value) send(kind, k, n);
    };
    var typed = k !== 'ie';
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(Step, {
      label: label,
      onDown: function onDown() {
        return send(kind + 'step', k, -1);
      },
      onUp: function onUp() {
        return send(kind + 'step', k, 1);
      }
    }, typed ? /*#__PURE__*/React.createElement("input", {
      "aria-label": "".concat(label, " value"),
      inputMode: "decimal",
      value: draft !== null ? draft : shown,
      onFocus: function onFocus() {
        return setDraft(String(value >= 99999 ? '' : value));
      },
      onChange: function onChange(e) {
        return setDraft(e.target.value);
      },
      onBlur: commit,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') e.currentTarget.blur();
        if (e.key === 'Escape') {
          setDraft(null);
          e.currentTarget.blur();
        }
      },
      className: "w-16 text-center font-mono bg-slate-900 border border-slate-600 rounded text-white"
    }) : /*#__PURE__*/React.createElement("span", {
      className: "w-16 text-center font-mono text-white"
    }, shown), /*#__PURE__*/React.createElement("span", {
      className: "w-12 text-[9px] text-slate-400"
    }, unit)));
  };
  var VentRemotePanel = function VentRemotePanel(_ref9) {
    var sim = _ref9.sim,
      m = _ref9.m;
    if (!VP || !sim.sendVentCommand) return null;
    var send = function send(type, key, val) {
      return sim.sendVentCommand(m.id, type, key, val);
    };
    var on = m.state !== 'off';
    var ready = m.state === 'standby' || m.state === 'ambient';
    var a350 = VP.modelOf(m.model) === 'a350'; /* the anaesthetic machine: no O2 enrichment key or screen lock */
    var sv = parseRows(m.sv),
      lv = parseRows(m.lv);
    var btn = 'px-2 py-0.5 rounded bg-slate-700 text-white text-[10px] font-bold disabled:opacity-30';
    return /*#__PURE__*/React.createElement("details", {
      className: "border-t border-slate-700 pt-1",
      "data-testid": "vent-remote"
    }, /*#__PURE__*/React.createElement("summary", {
      className: "cursor-pointer text-cyan-300 font-bold"
    }, "Control this ventilator"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1.5 mt-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      onClick: function onClick() {
        return send('power', null, on ? 0 : 1);
      }
    }, on ? 'Switch off' : 'Switch on'), m.state === 'ventilating' ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      onClick: function onClick() {
        return send('standby');
      }
    }, "Standby") : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      disabled: !ready,
      onClick: function onClick() {
        return send('start');
      }
    }, a350 ? 'Start therapy' : 'Start ventilation'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      disabled: !on,
      onClick: function onClick() {
        return send('silence');
      }
    }, "Silence alarms"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      disabled: !on,
      onClick: function onClick() {
        return send('o2');
      }
    }, a350 ? 'FG O2 100%' : 'O2 enrichment'), !a350 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      disabled: !on,
      onClick: function onClick() {
        return send('lock', null, m.locked ? 0 : 1);
      }
    }, m.locked ? 'Unlock screen' : 'Lock screen'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: btn,
      onClick: function onClick() {
        return send('fresh');
      }
    }, a350 ? 'Fresh machine' : 'Fresh ventilator')), on && /*#__PURE__*/React.createElement("label", {
      className: "flex items-center justify-between gap-2"
    }, /*#__PURE__*/React.createElement("span", null, "Mode"), /*#__PURE__*/React.createElement("select", {
      "aria-label": "Ventilator mode",
      value: m.mode === 'CPR' ? '' : m.mode,
      onChange: function onChange(e) {
        if (e.target.value) send('mode', e.target.value);
      },
      className: "min-w-0 bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[11px] text-white"
    }, m.mode === 'CPR' && /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "CPR"), VP.modesFor(m.model).map(function (_ref0) {
      var _ref1 = _slicedToArray(_ref0, 2),
        k = _ref1[0],
        name = _ref1[1];
      return /*#__PURE__*/React.createElement("option", {
        key: k,
        value: k
      }, name);
    }))), on && sv.map(function (r) {
      return /*#__PURE__*/React.createElement(ValueRow, {
        key: r[0],
        row: r,
        kind: "set",
        send: send
      });
    }), on && lv.length > 0 && /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", {
      className: "cursor-pointer text-slate-400"
    }, "Alarm limits"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1 mt-1"
    }, lv.map(function (r) {
      return /*#__PURE__*/React.createElement(ValueRow, {
        key: r[0],
        row: r,
        kind: "lim",
        send: send
      });
    }))), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-500"
    }, "Changes show on the ventilator as a colleague's would, and are logged as yours. Set it up before the candidate arrives to hand over deliberate errors.")));
  };
  window.VentControls = {
    VentPatientPanel: VentPatientPanel,
    VentRemotePanel: VentRemotePanel
  };
})();